import { Injectable, Injector, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';
import { SingletonCheckHelper } from '../helpers/singleton-check.helper';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable()
export class TcmCultureSystemService {

    get localeID(): string {
        return this._currentLocaleID;
    }

    get isCultureChanged(): boolean {
        return this._currentLocaleID !== this.injector.get(LOCALE_ID);
    }

    readonly cultureChanging$: Observable<void>;

    private readonly _cultureChangingSubject: Subject<void>;

    private _currentLocaleID: string;

    private readonly _cultureKey = "sys.culture";

    constructor(
        private localStorageService: LocalStorageService,
        private injector: Injector
    ) {
        SingletonCheckHelper.ensureSingleton(this);

        this._currentLocaleID = this.localStorageService.retrieve(this._cultureKey) || 'en-US';

        this._cultureChangingSubject = new Subject();
        this.cultureChanging$ = this._cultureChangingSubject.asObservable();
    }

    setCulture(culture: string) {
        if (culture) {
            this._currentLocaleID = culture;
            this.localStorageService.store(this._cultureKey, culture);

            if (this.isCultureChanged) {
                this._cultureChangingSubject.next();
            }
        }
    }
}
